import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Section } from '../components/Section';
import { SectionHeader } from '../components/SectionHeader';
import { LimeBandCTA } from '../components/LimeBandCTA';
export function About() {
  const teamMembers = [{
    name: 'Courtney Kay',
    title: 'Co-founder and Chief Executive Officer',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5RQDpEAYp5o4RussfAx4Gd/Courtney_Headshot.jpg',
    linkedin: 'https://linkedin.com/in/courtneylkay'
  }, {
    name: 'Andrew Burrows',
    title: 'Co-founder and Chief Product Officer',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/guV6DoFMoHLkgCDNtTFrb7/Andrew_headshot.jpg',
    linkedin: 'https://linkedin.com/in/andrewjburrows'
  }, {
    name: 'Jeff Ramminger',
    title: 'Co-founder and Chairman of the Board',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jG98f4NSo9sTUu6VsxE6ey/DSCF0274_copy.png',
    linkedin: 'https://linkedin.com/in/jeff-ramminger-bb5751'
  }];
  const advisors = [{
    name: 'Jeff Coyle',
    title: 'Head of Strategy, Siteimprove + MarketMuse Co-Founder'
  }, {
    name: 'Paul DeSantis',
    title: 'Public and Private Company CFO'
  }, {
    name: 'Matt Fox',
    title: 'Vice President of Product Management, Eptura'
  }, {
    name: 'Ellie Norman',
    title: 'Chief Marketing Officer, Formula E'
  }, {
    name: 'Alison Orsi',
    title: 'Board Advisor & Executive Coach + Former CMO EMEA, IBM'
  }, {
    name: 'Josh Welber',
    title: 'Software Engineering Manager, Google'
  }];
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-161">
      <Navbar data-id="element-162" />
      <main className="flex-grow" data-id="element-163">
        {/* Hero Section */}
        <Section className="pt-32 md:pt-48" data-id="element-164">
          <div className="flex flex-col md:flex-row md:gap-16 lg:gap-32" data-id="element-165">
            <div className="mb-8 md:mb-0 md:w-1/2" data-id="element-166">
              <h1 className="font-poppins font-normal text-3xl md:text-5xl text-black mb-6" data-id="element-167">
                About us
              </h1>
              <div className="space-y-4" data-id="element-168">
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-169">
                  What do a video game designer, a product marketer, and a
                  business executive have in common? In our case, a lot. A love
                  of sunset cruises, the roar of an F1 lap, a great guitar riff,
                  and yes, the occasional Below Deck boatmance. But what united
                  us professionally was one simple belief: customers don't
                  change unless the people inside the company do first.
                </p>
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-170">
                  Whether it's scaling a good story, a great pitch, or a new
                  idea, success depends on the belief and ability of the people
                  who bring it to life. And we believe that's where we can make
                  a difference.
                </p>
              </div>
            </div>
            <div className="md:w-1/2" data-id="element-171">
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-172">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nPPBCk5yfwoP15YmVYCj5N/About_Image_1.jpg" alt="About Us" className="w-full h-full object-cover" data-id="element-173" />
              </div>
            </div>
          </div>
        </Section>
        {/* POV Section */}
        <Section data-id="element-174">
          <div className="max-w-4xl mx-auto text-center" data-id="element-175">
            <h2 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-6" data-id="element-176">
              What we've learned
            </h2>
            <div className="space-y-4" data-id="element-177">
              <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-178">
                Throughout our work (most recently as Brand Publis) we've
                discovered that most organizations already have what they need
                to drive change. The insights are there. But the "how" is hidden
                in the conversations unfolding across the business, often
                trapped in silos or misunderstood with bias.
              </p>
              <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-179">
                Over time, misalignment across perspectives degrades the
                employee, customer, and partner experience. And when experience
                breaks down, belief does too.
              </p>
              <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-180">
                We exist to surface the conversations that matter and help
                leaders align on how to interpret them, so they can act faster,
                more effectively, and without guesswork.
              </p>
            </div>
          </div>
        </Section>
        {/* Mission & Vision Section */}
        <Section bgColor="lightgray" data-id="element-181">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 max-w-5xl mx-auto" data-id="element-182">
            <div className="text-center" data-id="element-183">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center" data-id="element-184">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8s784RYoRRkQJr2y9AJscg/Mission_icon.png" alt="Mission" className="w-full h-full object-contain" data-id="element-185" />
              </div>
              <h3 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-186">
                Our mission
              </h3>
              <p className="font-inter text-base leading-relaxed text-black" data-id="element-187">
                To enable better experiences by scaling understanding and action
                — without bias.
              </p>
            </div>
            <div className="text-center" data-id="element-188">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center" data-id="element-189">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wr6Dpd4A5PmHDzHbfCBceT/Vision_icon.png" alt="Vision" className="w-full h-full object-contain" data-id="element-190" />
              </div>
              <h3 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-191">
                Our vision
              </h3>
              <p className="font-inter text-base leading-relaxed text-black" data-id="element-192">
                To empower businesses to make decisions that maximize the ROI of
                every relationship.
              </p>
            </div>
          </div>
        </Section>
        {/* Team Section */}
        <Section data-id="element-193">
          <SectionHeader title="Our team" centered data-id="element-194" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 max-w-5xl mx-auto" data-id="element-195">
            {teamMembers.map((member, index) => <div key={index} className="text-center" data-id="element-196">
                <div className="w-48 h-48 mx-auto mb-4 rounded-full overflow-hidden bg-lightgray" data-id="element-197">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                objectPosition: 'center 20%'
              }} data-id="element-198" />
                </div>
                <div className="p-4" data-id="element-199">
                  <h4 className="font-poppins font-normal text-lg text-black mb-1" data-id="element-200">
                    {member.name}
                  </h4>
                  <p className="font-inter text-sm text-black mb-2" data-id="element-201">
                    {member.title}
                  </p>
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center text-black hover:text-lime transition-colors" aria-label={`${member.name}'s LinkedIn profile`} data-id="element-202">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-203">
                      <path d="M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z" data-id="element-204" />
                    </svg>
                  </a>
                </div>
              </div>)}
          </div>
        </Section>
        {/* Advisors Section */}
        <Section data-id="element-205">
          <SectionHeader title="Our Advisors" centered data-id="element-206" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-207">
            {advisors.map((advisor, index) => <div key={index} className="bg-white border border-lightgray rounded-md p-6" data-id="element-208">
                <h4 className="font-poppins font-normal text-base text-black mb-2" data-id="element-209">
                  {advisor.name}
                </h4>
                <p className="font-inter text-sm text-black" data-id="element-210">{advisor.title}</p>
              </div>)}
          </div>
        </Section>
        {/* CTA Band */}
        <LimeBandCTA text="Ready to get started?" linkText="Let's Connect" href="/contact" data-id="element-211" />
      </main>
      <Footer data-id="element-212" />
    </div>;
}